/**
 * Inserts the elements of the second array into the first array after the specified index.
 * If the index is invalid or either argument is not an array, returns an empty array.
 *
 * @param {T1[]} arr1 - The first array.
 * @param {T2[]} arr2 - The second array to insert into the first array.
 * @param {number} index - The index after which to insert the second array.
 * @returns {(T1|T2)[]} A new array with the elements of the second array inserted.
 */
const insertArrayAt = <T1 = unknown, T2 = T1>(
  arr1: T1[],
  arr2: T2[],
  index: number,
): (T1 | T2)[] => {
  if (
    !Array.isArray(arr1) ||
    !Array.isArray(arr2) ||
    index < 0 ||
    index > arr1?.length
  ) {
    return [];
  }
  return [...arr1.slice(0, index + 1), ...arr2, ...arr1.slice(index + 1)];
};

export default insertArrayAt;
